module.exports = "/virtual-football-league/img/amblems/right/logos/PSG.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/PSG.png
// module id = 2219
// module chunks = 4